export function resolveTryBookingEventId(event) {
  if (event?.trybookingEventId) return Number(event.trybookingEventId);
  if (event?.tryBookingID) return Number(event.tryBookingID);
  return null;
}

export function resolveVenueTryBookingEventId(venue) {
  if (venue?.trybookingEventId) return Number(venue.trybookingEventId);
  if (venue?.tryBookingID) return Number(venue.tryBookingID);
  return null;
}

export function hasTryBookingWidget(event) {
  if ((event?.venues?.length ?? 0) > 1) return false;
  if (event?.hasMultipleLocations && (event?.venues?.length ?? 0) > 0) return false;
  if (isAusLankaTicketUrl(event.ticketUrl ?? event.sessionURL)) return false;

  const eventId = resolveTryBookingEventId(event);
  if (!eventId || eventId <= 1) return false;
  if (isTryBookingUrl(event.ticketUrl ?? event.sessionURL)) return true;
  return eventId >= 100000;
}

export function isAusLankaTicketUrl(url) {
  return /auslankatickets\.com\/onlineticket\.php/i.test(String(url ?? ''));
}

export function venueUsesTryBookingWidget(venue) {
  if (isAusLankaTicketUrl(venue.ticketUrl ?? venue.sessionURL)) return false;

  const eventId = resolveVenueTryBookingEventId(venue);
  if (!eventId || eventId <= 1) return false;
  if (isTryBookingUrl(venue.ticketUrl ?? venue.sessionURL)) return true;
  return eventId >= 100000;
}

export function isTryBookingUrl(url) {
  return /trybooking\.com/i.test(String(url ?? ''));
}

export function buildTryBookingSessionURL(tryBookingID) {
  const id = String(tryBookingID ?? '').trim();
  if (!id) return '';
  return `https://www.trybooking.com/events/${id}`;
}

function extractAusLankaEventId(url) {
  const match = String(url ?? '').match(/[?&]eventid=(\d+)/i);
  return match?.[1] ?? null;
}

export function normalizeSessionURL(sessionURL, tryBookingID) {
  const url = String(sessionURL ?? '').trim();

  if (isAusLankaTicketUrl(url)) {
    const id = extractAusLankaEventId(url) ?? String(tryBookingID ?? '').trim();
    return id ? buildTryBookingSessionURL(id) : url;
  }

  if (!url && tryBookingID) {
    return buildTryBookingSessionURL(tryBookingID);
  }

  return url;
}

export function buildEventTicketUrl(event) {
  return event.ticketUrl ?? event.sessionURL ?? '';
}

export function applyTryBookingToSessions(event, sessions) {
  const eventId = resolveTryBookingEventId(event);
  if (!eventId) return sessions;

  return sessions.map((session) => ({
    ...session,
    trybookingEventId: eventId,
    trybookingSessionId: session.trybookingSessionId ?? event.trybookingSessionId,
    ticketUrl: session.ticketUrl || event.ticketUrl || event.sessionURL,
  }));
}
